import { hasVolvoNudgePeriods } from './nudge-period';

/** Volvo uses a fixed value per order; preserve zero and missing data. */
export function normalizeVolvoAov<T>(
  target: string | null | undefined,
  value: T,
): T | number {
  if (!hasVolvoNudgePeriods(target) || value == null) return value;
  const amount = Number(value);
  if (!Number.isFinite(amount)) return value;
  return amount === 0 ? 0 : 9000;
}
